/*
 * Visualiseur InstrumenPoche en Javascript et SVG
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const ActionAncetre = require('./actionAncetre')
module.exports = ActionEcarterCompas
/**
 * Écarte le compas
 * @extends iep.actionAncetre
 * @constructor
 * @param doc
 * @param ecartement
 * @param tempo
 * @param ec10
 */
function ActionEcarterCompas (doc, ecartement, tempo, ec10) {
  ActionAncetre.call(this, doc, tempo)
  this.ecartement = ecartement
  this.ec10 = (ec10 === null) ? 16 : parseFloat(ec10)
  // this.doc.compas.ecart = this.ecartement;
}
ActionEcarterCompas.prototype = new ActionAncetre()
/**
 * Fonction lançant l'animation d'écartement du compas sauf si immediat est true
 * @param {boolean} immediat
 */
ActionEcarterCompas.prototype.execute = function (immediat) {
  if (!immediat) this.doc.compas.lanceAnimationEcartement(this.ecartement, this.ec10)
  else {
    this.doc.compas.ecart = this.ecartement
    this.doc.compas.positionne()
  }
}
/** @inheritDoc */
ActionEcarterCompas.prototype.actionVisible = function () {
  return this.doc.getInstrumentVisibility(this.doc.compas, this.indice - 1)
}
